document.addEventListener('DOMContentLoaded', function() {
  const resellerGrid = document.getElementById('resellerGrid');
  const regionAccordion = document.getElementById('regionAccordion');
  
  if (!resellerGrid || !regionAccordion) {
    console.error('Required elements not found:', { resellerGrid, regionAccordion });
    return;
  }

  let regionToggles = [];
  let countryCheckboxes = [];
  let selectedCountries = new Set();
  let selectedRegions = new Set();
  let lastExpandedRegion = null; // Track the last expanded region
  let allCountriesData = {};
  let currentFilterMode = 'region'; // 'region' or 'country'
  
  // Initialize data structure - Updated for new JSON format
  function initializeData() {
    if (window.resellerData && window.resellerData.regions) {
      // Loop through regions and then countries within each region
      window.resellerData.regions.forEach(region => {
        region.countries.forEach(countryData => {
          allCountriesData[countryData.country] = countryData;
        });
      });
      // Generate dynamic filter sidebar
      generateFilterSidebar();
      
      // Set default state: first region expanded and selected
      if (window.resellerData.regions.length > 0) {
        const firstRegion = window.resellerData.regions[0];
        selectedRegions.add(firstRegion.id);
        lastExpandedRegion = firstRegion.id;
        currentFilterMode = 'region';
      }
    } else {
      console.error('No reseller data found or invalid format');
    }
  }
  
  // Wait for reseller data to be loaded
  window.addEventListener('resellerDataLoaded', function() {
    initializeData();
    displayFilteredContent();
  });

  if (window.resellerData) {
    initializeData();
    displayFilteredContent();
  }
  
  // Generate dynamic filter sidebar based on JSON data
  function generateFilterSidebar() {
    let html = '';
    
    if (window.resellerData && window.resellerData.regions) {
      window.resellerData.regions.forEach((region, index) => {
        const isFirstRegion = index === 0;
        const isExpanded = isFirstRegion ? 'true' : 'false';
        const displayStyle = isFirstRegion ? 'block' : 'none';
        const toggleIcon = isFirstRegion ? '−' : '+';
        
        // Sort countries alphabetically by countryLabel
        const sortedCountries = region.countries.slice().sort((a, b) => {
          return a.countryLabel.localeCompare(b.countryLabel);
        });
        
        html += `
          <div class="region-group" data-region="${region.id}">
            <button class="region-toggle" aria-expanded="${isExpanded}" data-region-id="${region.id}">
              <span>${region.label}</span>
              <span class="toggle-icon">${toggleIcon}</span>
            </button>
            <div class="country-list" style="display: ${displayStyle};">
        `;
        
        // Add countries for this region (now sorted)
        sortedCountries.forEach(countryData => {
          html += `
            <label class="country-checkbox">
              <input type="checkbox" value="${countryData.country}" data-region="${region.id}" />
              <span>${countryData.countryLabel}</span>
            </label>
          `;
        });
        
        html += `
            </div>
          </div>
        `;
      });
    }
    
    // Update the accordion with generated content
    regionAccordion.innerHTML = html;
    
    // Re-initialize event listeners for dynamically created elements
    initializeEventListeners();
  }
  
  // Initialize event listeners for dynamically created elements
  function initializeEventListeners() {
    // Update references to dynamically created elements
    regionToggles = document.querySelectorAll('.region-toggle');
    countryCheckboxes = document.querySelectorAll('.country-checkbox input[type="checkbox"]');
    
    // Accordion functionality - Only one region can be expanded at a time
    regionToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        const countryList = this.nextElementSibling;
        const icon = this.querySelector('.toggle-icon');
        const regionId = this.getAttribute('data-region-id');
        let shouldUpdateDisplay = regionId !== lastExpandedRegion;
        
        if (expanded) {
          // Collapsing current region
          this.setAttribute('aria-expanded', 'false');
          countryList.style.display = 'none';
          icon.textContent = '+';
          
          // Remove region from selection but keep it as last expanded
          selectedRegions.delete(regionId);
          // lastExpandedRegion remains the same to show data when all are closed
          
          // Clear any country selections from this region
          const regionCountryCheckboxes = countryList.querySelectorAll('input[type="checkbox"]');
          regionCountryCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
              checkbox.checked = false;
              shouldUpdateDisplay = true;
              selectedCountries.delete(checkbox.value);
            }
          });
          
        } else {
          // Expanding new region - first close all other regions
          regionToggles.forEach(otherToggle => {
            if (otherToggle !== this) {
              const otherExpanded = otherToggle.getAttribute('aria-expanded') === 'true';
              if (otherExpanded) {
                const otherCountryList = otherToggle.nextElementSibling;
                const otherIcon = otherToggle.querySelector('.toggle-icon');
                const otherRegionId = otherToggle.getAttribute('data-region-id');
                
                // Close other region
                otherToggle.setAttribute('aria-expanded', 'false');
                otherCountryList.style.display = 'none';
                otherIcon.textContent = '+';
                
                // Remove from selected regions
                selectedRegions.delete(otherRegionId);
                
                // Clear country selections from other region
                const otherRegionCheckboxes = otherCountryList.querySelectorAll('input[type="checkbox"]');
                otherRegionCheckboxes.forEach(checkbox => {
                  if (checkbox.checked) {
                    checkbox.checked = false;
                    selectedCountries.delete(checkbox.value);
                  }
                });
              }
            }
          });
          
          // Now expand current region
          this.setAttribute('aria-expanded', 'true');
          countryList.style.display = 'block';
          icon.textContent = '−';
          
          // Add region to selection and set as last expanded
          selectedRegions.add(regionId);
          lastExpandedRegion = regionId;
          currentFilterMode = 'region';
          
          // Clear country selections to show all countries in region
          selectedCountries.clear();
        }
        
        if (shouldUpdateDisplay) {
          updateDisplay();
        }
      });
      
      // Add keyboard navigation for accessibility
      toggle.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
    
    // Checkbox change handler
    countryCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        const country = this.value;
        const regionId = this.getAttribute('data-region');
        
        if (this.checked) {
          selectedCountries.add(country);
          currentFilterMode = 'country';
          
          // Ensure the region is in selectedRegions and set as last expanded
          selectedRegions.add(regionId);
          lastExpandedRegion = regionId;
        } else {
          selectedCountries.delete(country);
          
          // Check if any other countries in this region are selected
          const regionCheckboxes = document.querySelectorAll(`input[data-region="${regionId}"]`);
          const hasSelectedCountries = Array.from(regionCheckboxes).some(cb => cb.checked);
          
          if (!hasSelectedCountries) {
            // No countries selected in this region, switch back to region mode
            currentFilterMode = 'region';
          }
        }
        
        updateDisplay();
      });
    });
  }
  
  // Update display based on selected regions/countries
  function updateDisplay() {
    // Show loading state
    resellerGrid.innerHTML = '<div class="loading-spinner"><div class="spinner"></div></div>';
    
    // Simulate loading delay for better UX
    setTimeout(() => {
      displayFilteredContent();
      
      // Scroll reseller content into view
      const resellerContent = document.querySelector('.reseller-content');
      if (resellerContent) {
        resellerContent.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
      }
    }, 200);
  }
  
  // Display filtered content based on current selection
  function displayFilteredContent() {
    let html = '';
    
    if (window.resellerData && window.resellerData.regions) {
      if (currentFilterMode === 'country' && selectedCountries.size > 0) {
        // Show specific selected countries
        html = displaySelectedCountries();
      } else if (selectedRegions.size > 0) {
        // Show all countries from selected regions
        html = displaySelectedRegions();
      } else if (lastExpandedRegion) {
        // Show data from last expanded region when all are closed
        html = displayLastExpandedRegion();
      } else {
        // Show no results if nothing is selected
        html = generateNoResultsMessage();
      }
    }
    
    if (html === '') {
      html = generateNoResultsMessage();
    }
    
    resellerGrid.innerHTML = html;
  }
  
  // Display retailers from selected regions
  function displaySelectedRegions() {
    let html = '';
    
    window.resellerData.regions.forEach(region => {
      if (selectedRegions.has(region.id) && region.countries.length > 0) {
        html += `<div class="region-section" data-region="${region.id}">`;
        html += `<h2 class="region-title">${region.label}</h2>`;
        const sortedCountries = region.countries.slice().sort((a, b) => {
          return a.countryLabel.localeCompare(b.countryLabel);
        });
        
        sortedCountries.forEach(countryData => {
          html += generateCountrySection(countryData);
        });
        
        html += `</div>`;
      }
    });
    
    return html;
  }
  
  // Display retailers from last expanded region
  function displayLastExpandedRegion() {
    let html = '';
    
    const region = window.resellerData.regions.find(r => r.id === lastExpandedRegion);
    if (region && region.countries.length > 0) {
      html += `<div class="region-section" data-region="${region.id}">`;
      html += `<h2 class="region-title">${region.label}</h2>`;
      const sortedCountries = region.countries.slice().sort((a, b) => {
        return a.countryLabel.localeCompare(b.countryLabel);
      });
      
      sortedCountries.forEach(countryData => {
        html += generateCountrySection(countryData);
      });
      
      html += `</div>`;
    }
    
    return html;
  }
  
  // Display selected countries - Updated to maintain regional organization
  function displaySelectedCountries() {
    let html = '';
    
    window.resellerData.regions.forEach(region => {
      const regionCountries = region.countries.filter(countryData => 
        selectedCountries.has(countryData.country)
      );
      
      if (regionCountries.length > 0) {
        html += `<div class="region-section" data-region="${region.id}">`;
        html += `<h2 class="region-title">${region.label}</h2>`;
        const sortedCountries = regionCountries.slice().sort((a, b) => {
          return a.countryLabel.localeCompare(b.countryLabel);
        });
        
        sortedCountries.forEach(countryData => {
          html += generateCountrySection(countryData);
        });
        
        html += `</div>`;
      }
    });
    
    return html;
  }
  
  // Generate HTML for a country section
  function generateCountrySection(countryData) {
    let html = `
      <div class="country-section" data-country="${countryData.country}">
        <h3 class="country-title">${countryData.countryLabel}</h3>
        <div class="retailers-grid">
    `;
    
    countryData.retailers.forEach(retailer => {
      html += generateRetailerCard(retailer);
    });
    
    html += `
        </div>
      </div>
    `;
    
    return html;
  }
  
  // Generate HTML for a retailer card
  function generateRetailerCard(retailer) {
    return `
      <a href="${retailer.url}" class="retailer-card" target="_blank" rel="noopener noreferrer">
        <div class="retailer-card-content">
          <div class="retailer-logo">
            <img src="${retailer.logo}" alt="${retailer.name}" loading="lazy" onerror="this.style.display='none'">
          </div>
          <div class="retailer-name">${retailer.name}</div>
        </div>
      </a>
    `;
  }
  
  // Generate no results message
  function generateNoResultsMessage() {
    return `
      <div class="no-results">
        <h3>No retailers found</h3>
        <p>Please select a region or specific countries to view available retailers.</p>
      </div>
    `;
  }
  
  // Search functionality (optional)
  function setupSearch() {
    const searchInput = document.getElementById('retailerSearch');
    if (searchInput) {
      searchInput.addEventListener('input', function(e) {
        const searchTerm = e.target.value.toLowerCase();
        filterBySearch(searchTerm);
      });
    }
  }
  
  // Filter retailers by search term - Updated for new structure
  function filterBySearch(searchTerm) {
    const regionSections = document.querySelectorAll('.region-section');
    
    regionSections.forEach(regionSection => {
      const countrySections = regionSection.querySelectorAll('.country-section');
      let hasVisibleCountries = false;
      
      countrySections.forEach(countrySection => {
        const retailers = countrySection.querySelectorAll('.retailer-card');
        let hasVisibleRetailers = false;
        
        retailers.forEach(card => {
          const retailerName = card.querySelector('.retailer-name').textContent.toLowerCase();
          if (retailerName.includes(searchTerm)) {
            card.style.display = 'block';
            hasVisibleRetailers = true;
          } else {
            card.style.display = 'none';
          }
        });
        
        // Hide/show country section based on visible retailers
        if (hasVisibleRetailers) {
          countrySection.style.display = 'block';
          hasVisibleCountries = true;
        } else {
          countrySection.style.display = 'none';
        }
      });
      
      // Hide/show region section based on visible countries
      regionSection.style.display = hasVisibleCountries ? 'block' : 'none';
    });
  }
  
  // Initialize on page load
  setupSearch();
  
  // Handle window resize for responsive behavior
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      adjustLayoutForMobile();
    }, 250);
  });
  
  // Adjust layout for mobile devices
  function adjustLayoutForMobile() {
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile && regionToggles.length > 0) {
      // On mobile, ensure only one region is expanded
      let expandedCount = 0;
      regionToggles.forEach((toggle, index) => {
        if (toggle.getAttribute('aria-expanded') === 'true') {
          expandedCount++;
          if (expandedCount > 1) {
            toggle.click(); // Close extra expanded regions
          }
        }
      });
    }
  }
  
  // Initial mobile check
  adjustLayoutForMobile();
}); 